export enum StorageKeys {
  Token = "nuveToken",
  IsPrivacyChecked = "nuveIsPrivacyChecked",
  UserProfile = "nuveUserProfile",
  TechnicianHomeowner = "nuveTechnicianHomeowner",
  TechnicianSN = "nuveTechnicianSN",
  UserTemperatureScale = "userTemperatureScale",
  UserTheme = "userTheme",
  UserLogo = "userLogo",
}
